// F10 dev menu: tool links, quick teleports, and the WEAPON TUNER — precise
// flip/rotate/offset/scale of the equipped weapon's grip with live preview,
// Save posts the full grip config to tools/tune-server.mjs (:8111) which
// writes assets/weapons/grip-config.json (loaded at boot by weapons.js).

const TELEPORTS = [
  ['Kyst-spawn', 3500, -1000], ['Primorsk centrum', 3600, -250],
  ['Vrag-motorvej', 2170, 35], ['Birkeskov', 1000, 1200],
  ['Garnison-12', -1600, 1400], ['Bjergene (sne)', -3400, 3200],
  ['Flyvepladsen', -3400, 2600], ['Pionerlejren', 3500, 2400],
];
const DEG = Math.PI / 180;

export class DebugMenu {
  constructor(game) {
    this.game = game; // { scene, camera, player, props, terrain? }
    this.el = this.panel('debugMenu', '10px', '360px');
    this.tuner = this.panel('weaponTuner', '380px', '330px');
    this.buildMenu();
    window.addEventListener('keydown', (e) => {
      if (e.code === 'F10') {
        e.preventDefault();
        const on = this.el.style.display === 'none';
        this.el.style.display = on ? 'block' : 'none';
        if (!on) this.tuner.style.display = 'none';
      }
    });
  }

  panel(id, top, width) {
    const el = document.createElement('div');
    el.id = id;
    el.style.cssText = `position:fixed;top:${top};left:10px;width:${width};z-index:60;`
      + 'background:#141a20ee;color:#cfd3d8;font:12px/1.6 ui-monospace,monospace;'
      + 'border:1px solid #2c3542;border-radius:8px;padding:10px 12px;display:none;'
      + 'max-height:44vh;overflow:auto';
    document.body.appendChild(el);
    return el;
  }

  btn(label, fn, style = '') {
    const b = document.createElement('button');
    b.textContent = label;
    b.style.cssText = 'background:#22303c;color:#cfd3d8;border:1px solid #3a4a5a;'
      + 'border-radius:4px;margin:1px;padding:2px 7px;cursor:pointer;font:11px ui-monospace,monospace;' + style;
    b.onclick = fn;
    return b;
  }

  buildMenu() {
    const M = this.el;
    M.innerHTML = '<b style="color:#e8b45a">ASHVALE DEV (F10)</b><br>';
    const row = (title) => {
      const d = document.createElement('div');
      d.innerHTML = `<span style="color:#8a93a0">${title}</span> `;
      M.appendChild(d);
      return d;
    };
    const links = row('Sider: ');
    for (const [t, href] of [['Verden', '/'], ['Gym', '/?gym=1'], ['Kort', '/map.html'],
      ['Anims', '/anims.html'], ['Registry', '/registry.html'], ['Træer', '/vegbake.html']]) {
      links.appendChild(this.btn(t, () => { location.href = href; }));
    }
    row('Taster: M kort · F1 hjælp · F2 anim · F3 perf · F6 vejr (laptop: ofte Fn+F-tast)');
    const panels = row('Paneler: ');
    panels.appendChild(this.btn('🎬 Anim-debug (F2)', () => {
      window.__animdbg?.toggle();
      this.el.style.display = 'none';
    }, 'background:#22383a'));
    if (this.game.terrain) {
      const tp = row('Teleport: ');
      for (const [name, x, z] of TELEPORTS) {
        tp.appendChild(this.btn(name, () => {
          const g = this.game;
          g.player.root.position.set(x, g.terrain.getHeight(x, z), z);
        }));
      }
    }
    const tools = row('Værktøj: ');
    tools.appendChild(this.btn('⚙ Våben-tuner', () => {
      const on = this.tuner.style.display === 'none';
      this.tuner.style.display = on ? 'block' : 'none';
      if (on) this.buildTuner();
    }, 'background:#3a2c22'));
  }

  activeRoot() {
    const roots = this.game.props?.roots || {};
    const key = this.game.props?.active?.();
    return key && roots[key] ? { key, root: roots[key] } : null;
  }

  buildTuner() {
    const T = this.tuner;
    const a = this.activeRoot();
    T.innerHTML = '<b style="color:#e8b45a">VÅBEN-TUNER</b> ';
    if (!a) {
      T.innerHTML += '<br>Tag et våben frem først (tast 2-7).';
      return;
    }
    T.innerHTML += `<span style="color:#9fd49f">[${a.key}]</span>`
      + '<div style="color:#8a93a0">pos i mm/cm · rot i grader · flip = 180°</div>';
    const stat = document.createElement('div');
    stat.style.cssText = 'color:#9fd49f;margin:4px 0;white-space:pre';
    const show = () => {
      const { root } = this.activeRoot() || a;
      stat.textContent = `p ${root.position.asArray().map((v) => v.toFixed(3)).join(', ')}\n`
        + `r ${root.rotation.asArray().map((v) => (v / DEG).toFixed(1)).join('°, ')}°\n`
        + `s ${root.scaling.x.toFixed(2)}`;
    };
    const rowFor = (label, steps, apply) => {
      const d = document.createElement('div');
      d.append(label + ' ');
      for (const [t, v] of steps) d.appendChild(this.btn(t, () => { apply(v); show(); }));
      T.appendChild(d);
    };
    for (const [ax, i] of [['pX', 0], ['pY', 1], ['pZ', 2]]) {
      rowFor(ax, [['-5cm', -0.05], ['-5mm', -0.005], ['+5mm', 0.005], ['+5cm', 0.05]],
        (v) => { const r = this.activeRoot().root; r.position.set(...[0, 1, 2].map((j) => r.position.asArray()[j] + (j === i ? v : 0))); });
    }
    for (const [ax, i] of [['rX', 0], ['rY', 1], ['rZ', 2]]) {
      rowFor(ax, [['-15°', -15 * DEG], ['-1°', -DEG], ['+1°', DEG], ['+15°', 15 * DEG], ['flip', Math.PI]],
        (v) => { const r = this.activeRoot().root; const e = r.rotation.asArray(); e[i] += v; r.rotation.set(e[0], e[1], e[2]); });
    }
    rowFor('skala', [['-10%', 0.9], ['-1%', 0.99], ['+1%', 1.01], ['+10%', 1.1]],
      (v) => { const r = this.activeRoot().root; r.scaling.scaleInPlace(v); });
    const act = document.createElement('div');
    act.style.marginTop = '6px';
    act.appendChild(this.btn('Zoom hånd', () => {
      const c = this.game.camera;
      c.dist = 1.1; c.pitch = 0.15;
    }));
    act.appendChild(this.btn('Normal kamera', () => {
      const c = this.game.camera;
      c.dist = 3.4; c.pitch = 0.12;
    }));
    act.appendChild(this.btn('💾 GEM', async () => {
      const roots = this.game.props.roots;
      const cfg = {};
      for (const [k, r] of Object.entries(roots)) {
        cfg[k] = { p: r.position.asArray(), r: r.rotation.asArray(), s: r.scaling.x };
      }
      try {
        const res = await fetch(`http://${location.hostname}:8111/save`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cfg),
        });
        stat.textContent = res.ok ? '✓ GEMT — grip-config.json opdateret' : `✗ fejl ${res.status}`;
      } catch {
        stat.textContent = '✗ tune-server svarer ikke — kør: node tools/tune-server.mjs';
      }
    }, 'background:#2c4a2c'));
    T.appendChild(act);
    T.appendChild(stat);
    show();
  }
}
